import { render } from "./helper-page.vue?vue&type=template&id=2d885098&scoped=true"
import script from "./helper-page.vue?vue&type=script&lang=js"
export * from "./helper-page.vue?vue&type=script&lang=js"

import "./helper-page.vue?vue&type=style&index=0&id=2d885098&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d885098"]])

export default __exports__